export enum RolesEnum {
  SuperAdmin ="SUPERADMIN",
  Admin ="ADMIN",
  LogisticsTeam ="LOGISTICSTEAM",
  Site ="SITE"
}
